export default "__VITE_ASSET__3feea259__"